module.exports = __webpack_public_path__ + "img/slide-1.ru.ebc3f66e.png";